exports.f = require('./_wks');


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-polyfill/~/core-js/modules/_wks-ext.js
 ** module id = 78
 ** module chunks = 0
 **/